import { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

/*
  ImagesTab
  Mosaic of embedded lecture figures with caption. Click → opens a
  light-box preview.
*/

export default function ImagesTab({ studyPack }) {
  const items = Array.isArray(studyPack?.embeddedImages) ? studyPack.embeddedImages : [];
  const [open, setOpen] = useState(null);

  if (items.length === 0) {
    return (
      <Paper variant="outlined" sx={{ p: 4, textAlign: "center", borderRadius: 3, borderStyle: "dashed" }}>
        <Typography variant="body2" color="text.secondary">
          No figures were extracted from this lecture.
        </Typography>
      </Paper>
    );
  }

  return (
    <>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr 1fr", md: "1fr 1fr 1fr" },
          gap: 1.5,
        }}
      >
        {items.map((img, i) => (
          <Paper
            key={i}
            variant="outlined"
            onClick={() => setOpen(img)}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              cursor: "pointer",
              transition: "transform .15s ease, box-shadow .15s ease",
              "&:hover": { transform: "translateY(-2px)" },
            }}
          >
            <Box
              component="img"
              src={img.imageUrl}
              alt={img.caption || `Figure ${i + 1}`}
              sx={{
                width: "100%",
                height: 180,
                objectFit: "cover",
                display: "block",
                backgroundColor: "rgba(15,23,42,0.04)",
              }}
            />
            {img.caption ? (
              <Box sx={{ p: 1.2 }}>
                <Typography variant="caption" color="text.secondary">
                  {img.caption}
                </Typography>
              </Box>
            ) : null}
          </Paper>
        ))}
      </Box>

      <Dialog open={!!open} onClose={() => setOpen(null)} maxWidth="md" fullWidth>
        <DialogContent sx={{ p: 0, position: "relative" }}>
          <IconButton
            onClick={() => setOpen(null)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              backgroundColor: "rgba(0,0,0,0.55)",
              color: "#fff",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
              zIndex: 1,
            }}
            size="small"
          >
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
          {open ? (
            <>
              <Box
                component="img"
                src={open.imageUrl}
                alt={open.caption || ""}
                sx={{ width: "100%", display: "block", maxHeight: "78vh", objectFit: "contain", backgroundColor: "#000" }}
              />
              {open.caption ? (
                <Box sx={{ p: 1.5 }}>
                  <Typography variant="body2">{open.caption}</Typography>
                </Box>
              ) : null}
            </>
          ) : null}
        </DialogContent>
      </Dialog>
    </>
  );
}
